export default {
  server: {
    url: 'http://internal-uw2-webdev-qa-splunk-com-portal-97340.us-west-2.elb.amazonaws.com'
  },
  recaptcha: {
    enabled: false
  },
  links: {
    lostPassword: 'https://www.splunk.com/en_us/page/lost_password',
    lostUsername: 'https://www.splunk.com/en_us/page/retrieve_username',
    createAccount: 'https://www.splunk.com/en_us/page/sign_up',
    partnerPortal: 'https://login.splunk.com/en_us/index.php?module=roles&func=showloginform&redirecturl=https%3A%2F%2Flogin.splunk.com%2Fen_us%2Fpage%2Fsso_redirect%3Ftype%3Dimpartner&artid=partner',
  }
};
